// imports
import * as THREE from "three"

// classes
import Experience from "./Experience"

export default class Camera
{
    constructor() 
    {
        // setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.debug = this.experience.debug

        this.setInstance()
    }

    setInstance()
    {
        this.instanceParameters = 
        {
            fov: 75,
            aspectRatio: this.sizes.aspectRatio,
            near: 0.1,
            far: 100,

            position:
            {
                x: 0.8,
                y: 2.3,
                z: -2
            },

            rotation:
            {
                x: -2.3,
                y: 0.3,
                z: 2.9
            }
        }

        this.instance = new THREE.PerspectiveCamera( 
            this.instanceParameters.fov,
            this.instanceParameters.aspectRatio,
            this.instanceParameters.near,
            this.instanceParameters.far,
        )


        this.instance.position.set( ...Object.values( this.instanceParameters.position ) )
        this.instance.rotation.set( ...Object.values( this.instanceParameters.rotation ) )

        this.scene.add( this.instance )
    }

    resize()
    {
        this.instanceParameters.aspectRatio = this.sizes.aspectRatio
        this.instance.aspect = this.instanceParameters.aspectRatio
        this.instance.updateProjectionMatrix()
    }

    setDebug()
    {
        this.folder = this.debug.ui.addFolder(  
        {
            title: "Camera",
            expanded: false,
            
        } ).on( "change", ( _changeInfo ) => this.handleChange( _changeInfo ) )

        this.tabs = this.folder.addTab( 
        {
            pages:
            [
                { title: "Parameters" },
                { title: "Positions" },
                { title: "Rotation" },
            ]
        } )

        this.parametersFolder = this.tabs.pages[0]
        this.positionsFolder = this.tabs.pages[1]
        this.rotationFolder = this.tabs.pages[2]

        // parameters
        this.parametersFolder.addInput( this.instanceParameters, "fov",
        {
            min: 0,
            max: 150,
            step: 0.01
        } )
        this.parametersFolder.addInput( this.instanceParameters, "far", 
        {
            min: 100,
            max: 10000,
            step: 0.01
        } )

        // positions
        this.positionsFolder.addInput( this.instanceParameters.position, "x",
        {
            min: -100,
            max: 100,
            step: 0.001
        } )
        this.positionsFolder.addInput( this.instanceParameters.position, "y",
        {
            min: -100,
            max: 100,
            step: 0.001
        } )
        this.positionsFolder.addInput( this.instanceParameters.position, "z",
        {
            min: -100,
            max: 100,
            step: 0.001
        } )

        this.rotationFolder.addInput( this.instanceParameters.rotation, "x",
        {
            min: Math.PI * 0.25,
            max: Math.PI * 4,
            step: 0.001
        } )
        this.rotationFolder.addInput( this.instanceParameters.rotation, "y",
        {
            min: Math.PI * 0.25,
            max: Math.PI * 4,
            step: 0.001
        } )
        this.rotationFolder.addInput( this.instanceParameters.rotation, "z",
        {
            min: Math.PI * 0.25,
            max: Math.PI * 4,
            step: 0.001
        } )
    }

    handleChange( _changeInfo )
    {
        this.instance.fov = this.instanceParameters.fov
        this.instance.far = this.instanceParameters.far
        this.instance.position.set( ...Object.values( this.instanceParameters.position ) )
        this.instance.rotation.set( ...Object.values( this.instanceParameters.rotation ) )
    }
}